import { ExtensionComponentProps } from 'piral'
import * as React from 'react'

export default function SystemSettingsMenu(props: ExtensionComponentProps<any>) {
    return (
        <sp-menu-item href="/settings">
            <sp-icon-settings slot="icon"></sp-icon-settings>
            System settings
        </sp-menu-item>
    )
}
